












































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { MessageController } from '@/services/request.service';
import SendMessageForm from '@/components/SendMessageForm.vue';
import { RouteRecord } from 'vue-router';
import { saveAs } from 'file-saver';
import moment from 'moment';
import config from '@/school.config';
import { getSchoolInfo } from '@/utils/utils';
import { formatCurrency } from '@/utils/utils';

@Component({
  components: {
    SendMessageForm,
  },
})
export default class ReceiveMsgDetail extends Vue {
  @Prop({ default: () => {} }) public detailInfo!: any;
  @Prop({ default: true }) public reply!: boolean;
  public moment = moment;
  public isReply: boolean = false;
  public isShowButton: boolean = true;
  public isShowCharge: boolean = true;
  public contentDetail: any = {};
  public chargeData: Array<any> = [];
  public config = config;
  public isContent: boolean = false;
  public isMobileContent: boolean = false;
  public formatCurrency = formatCurrency;

  // public orderCharges: Array<any> = [];

  public get isMobile(): boolean {
    const ua = window.navigator.userAgent;
    const isAndroid = /(?:Android)/.test(ua);
    // const isFireFox = /(?:Firefox)/.test(ua);
    // const isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua));
    const isPhone = /(?:iPhone)/.test(ua);
    return isAndroid || isPhone;
  }
  public created() {
    // const content=this.detailInfo.content
    // const contentFlag=/(style)/.test(content)
    if (this.detailInfo.jsonFlag === true) {
      this.contentDetail = JSON.parse(this.detailInfo.content);
      this.chargeData = this.contentDetail.orderCharges;
    }
  }
  public get school() {
    return getSchoolInfo().shortName;
  }
  public get columns() {
    return [
      {
        dataIndex: 'studentName',
        key: 'studentName',
        slots: { title: 'customTitle' },
        scopedSlots: { customRender: 'studentName' },
        title: this.$tc('feeStudent'),
      },
      {
        dataIndex: 'chargeName',
        key: 'chargeItem',
        slots: { title: 'customTitle' },
        scopedSlots: { customRender: 'chargeName' },
        title: this.$tc('chargeItem'),
      },

      {
        dataIndex: 'money',
        key: 'money',
        slots: { title: 'customTitle' },
        scopedSlots: { customRender: 'money' },
        title: this.$tc('chargeAmount'),
      },
      {
        dataIndex: 'benefitMoney',
        key: 'benefitMoney',
        slots: { title: 'customTitle' },
        scopedSlots: { customRender: 'benefitMoney' },
        title: this.$tc('preferentialAmount'),
      },

      {
        dataIndex: 'receivableMoney',
        key: 'receivableMoney',
        slots: { title: 'customTitle' },
        scopedSlots: { customRender: 'receivableMoney' },
        title: this.$tc('amountReceivable'),
      },
      {
        dataIndex: 'semesterName',
        key: 'semesterName',
        slots: { title: 'customTitle' },
        scopedSlots: { customRender: 'semesterName' },
        title: this.$tc('applicableSemester'),
      },
    ];
  }
  public get locale(): string {
    return this.$i18n.locale;
  }
  // public isShowbutton() {
  //   this.isShowButton = !this.isShowButton;
  // }
  public isShowcharge() {
    this.isShowCharge = !this.isShowCharge;
  }
  public openFile(resource: any): void {
    const suffixArray = ['doc', 'docx', 'xls', 'xlsx'];
    if (suffixArray.includes(resource.type)) {
      this.download(resource);
    } else {
      window.open(resource.resourceUrl);
    }
  }

  public download(info: any): void {
    saveAs(info.resourceUrl, info.name);
  }

  public changeFlag(flag: boolean): void {
    this.isReply = flag;
  }
  public contentChange() {
    this.isContent = !this.isContent;
  }
  public mobileContentChange() {
    this.isMobileContent = !this.isMobileContent;
  }
  public sendMsg(values: any): void {
    MessageController.replyMessageBatch(values).then(res => {
      this.$message.success(this.$tc('sendSuccess'));
      this.$router.push({ name: 'sent', query: { studentId: this.detailInfo.toMemberId } });
    });
  }
}
